<template>
  <div class="installation-success-container">
    <h1>NewebPay 應用程式安裝成功！</h1>
    <router-link to="/settings">
      <button>前往設定金鑰</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'InstallationSuccess',
}
</script>

<style scoped>
.installation-success-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 使其佔滿整個可視高度 */
  text-align: center;
}
h1 {
  margin-bottom: 2rem;
}
button {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>